import { Menu, MenuItem } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as DotsVerticalIcon } from "components/Icons/dots-vertical.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useContextMenu } from "hooks/contextMenu";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: {
      width: "24px",
      height: "24px",
      minWidth: "24px",
      backgroundColor: theme.gray50,
      color: theme.gray500,
      borderRadius: "4px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      "& svg": {
        width: "16px",
        height: "16px",
      },
    },
  }),
);

interface Props {
  actions: {
    id: string;
    onClick: (value: string) => void;
    label: string;
    isDisabled?: boolean;
  }[];
  "data-test-id": string;
}

export const DotMenu = ({ actions, "data-test-id": dataTestId }: Props) => {
  const classes = useStyles();
  const contextMenu = useContextMenu();

  return (
    <div className={classes.wrapper}>
      <DotsVerticalIcon
        onClick={contextMenu.handleMenuOpen}
        data-test-id={`${dataTestId}-menu`}
      />
      <Menu
        anchorEl={contextMenu.anchor}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        onClose={contextMenu.handleMenuClose}
        open={contextMenu.isMenuOpen}
        transformOrigin={{ horizontal: "center", vertical: "top" }}
      >
        {actions.map((action, index) => (
          <MenuItem
            key={index}
            data-test-id={`${dataTestId}-${action.id}`}
            disabled={action.isDisabled}
            onClick={() => {
              contextMenu.handleMenuClose();
              action.onClick(action.id);
            }}
          >
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
